// @flow
import Swal from 'sweetalert2';
import UserNotifications from './userNotifications';

// The support team's WhatsApp (the error page sends there too): the way out when the chat doesn't open
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/5521998007587';
// How long the messenger gets to show up before the WhatsApp offer
export const SUPPORT_CHAT_TIMEOUT = 4000;

// What Intercom last told us: the messenger is open, and when it last showed up
const messenger = { open: false, shownAt: 0 };
let offering = false;

const openWhatsApp = () => {
  if (window.cordova && window.cordova.InAppBrowser) window.cordova.InAppBrowser.open(SUPPORT_WHATSAPP_URL, '_system');
  else window.open(SUPPORT_WHATSAPP_URL, '_blank', 'noopener');
};

const offerWhatsApp = () => {
  // Never over another dialog: opening this one would dismiss it
  if (Swal.isVisible()) return;
  offering = true;
  UserNotifications.customConfirmI18n('alert/support_chat_unavailable', 'button/support_whatsapp', 'button/support_not_now')
    .then((confirmed) => {
      offering = false;
      if (confirmed) openWhatsApp();
    });
};

// Each call registers again (Intercom may drop handlers on shutdown); they only set the same two fields
const listen = () => {
  window.Intercom('onShow', () => {
    messenger.open = true;
    messenger.shownAt = Date.now();
    // The messenger was only slow: the offer that went up meanwhile goes away
    if (offering) Swal.close();
  });
  window.Intercom('onHide', () => { messenger.open = false; });
};

// Opens the support chat (Intercom). When the messenger doesn't show up (the widget blocked or not loaded,
// no connection) the tap used to do nothing at all: the person is offered the support's WhatsApp instead.
export const openSupportChat = () => {
  if (!window.Intercom) {
    offerWhatsApp();
    return;
  }
  listen();
  window.Intercom('show');
  if (messenger.open) return;
  const tappedAt = Date.now();
  setTimeout(() => {
    if (!messenger.open && messenger.shownAt < tappedAt) offerWhatsApp();
  }, SUPPORT_CHAT_TIMEOUT);
};
